"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var DocumentPageSkeleton_1 = __importDefault(require("./DocumentPageSkeleton"));
var preloadedImages = {};
var useStyles = styles_1.makeStyles({
    root: {
        display: 'block',
        height: 'auto',
        width: '100%',
    },
});
var preloadImageFromUrl = function (url) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onerror = reject;
        img.onload = function () { return resolve(url); };
        img.src = url;
        // Attach image object to preloadedImages object to stop it getting garbage collected
        preloadedImages[url] = img;
    });
};
var DocumentPageImage = function (_a) {
    var onImageLoadError = _a.onImageLoadError, imageUrl = _a.imageUrl, pageHeight = _a.pageHeight, pageWidth = _a.pageWidth;
    var classes = useStyles();
    var _b = react_1.useState(false), isImageLoaded = _b[0], setIsImageLoaded = _b[1];
    var _c = react_1.useState(0), imageLoadTryCount = _c[0], setImageLoadTryCount = _c[1];
    react_1.useEffect(function () {
        if (!imageUrl)
            return;
        setIsImageLoaded(false);
        var tryCount = imageLoadTryCount + 1;
        setImageLoadTryCount(tryCount);
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, preloadImageFromUrl(imageUrl)];
                    case 1:
                        _a.sent();
                        setIsImageLoaded(true);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        onImageLoadError(err_1, tryCount);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); })();
    }, [imageUrl]);
    var isPageReady = imageUrl && isImageLoaded;
    return isPageReady ? (react_1.default.createElement("img", { className: classes.root, draggable: false, height: pageHeight, src: imageUrl, width: pageWidth })) : (react_1.default.createElement(DocumentPageSkeleton_1.default, { pageHeight: pageHeight, pageWidth: pageWidth }));
};
exports.default = DocumentPageImage;
//# sourceMappingURL=DocumentPageImage.js.map